import { setCookie, removeCookie, getCookie } from "./cookie-storage";

const AUTH_KEYS = ["auth-token", "refresh-token", "device-id", "username"];

export const storeAuthCookies = ({ authToken, refreshToken, deviceId, username }) => {
  if (authToken) setCookie("auth-token", authToken);
  if (refreshToken) setCookie("refresh-token", refreshToken);
  if (deviceId) setCookie("device-id", deviceId);
  if (username) setCookie("username", username);
};

export const clearAuthCookies = () => {
  AUTH_KEYS.forEach(removeCookie);
};

export const getAuthCookies = () => {
  return {
    authToken: getCookie("auth-token"),
    refreshToken: getCookie("refresh-token"),
    deviceId: getCookie("device-id"),
    username: getCookie("username"),
  };
};
